import { createContext, RefObject } from 'react';

import { LineChart } from 'src/components/LineChart/types';

interface ChartContextType {
    chartData: LineChart;
    width: number;
    height: number;
    chartDimension: number;
    containerRef: RefObject<HTMLDivElement>;
}

const ChartContext = createContext<ChartContextType>({
    chartData: [],
    width: 0,
    height: 0,
    chartDimension: 0,
    containerRef: { current: null },
});
export default ChartContext;
